// extracted by mini-css-extract-plugin
export var Section = "content-module--Section--e6ab7";
export var SectionWrapper = "content-module--SectionWrapper--d0fe1";
export var searchContainer = "content-module--searchContainer--d5c28";